import { Component, OnInit, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import { ClientService } from '../client.service';
import { OAuthClientDetail } from '../oauth-client-detail';

@Component({
    selector : 'app-client-list',
    templateUrl : './client-list.component.html',
})
export class ClientListComponent implements OnInit {
    page = 0;
    size = 10;
    totalPage = 0;
    totalElement = 0;
    pageStart: number;
    pageEnd: number;
    numberOfElements: number;
    clients: Array<OAuthClientDetail> = new Array<OAuthClientDetail>();

    constructor(public router: Router, private clientService: ClientService) {}

    ngOnInit() {
      this.getClients();
    }

    getClients() {
      this.clientService.getClients(this.page, this. size).subscribe(response => {
        const data = response.json();

        this.totalElement = data.totalElements;
        this.totalPage = data.totalPages;
        this.numberOfElements = data.numberOfElements;
        this.pageStart = Math.floor(((this.page) / 10)) * 10 + 1;
        this.pageEnd = (this.pageStart + 9);
        if ( this.pageEnd > this.totalPage) {
          this.pageEnd = this.totalPage;
        }
        this.clients = data.content;

      });
    }

    paginationHandler(event: number) {
      this.page = event;
      this.getClients();
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/client/list/client-list.component.ts